export default __webpack_public_path__ + "static/media/Bracers of the Usurper.8f16ee93.jpg";